<template>
  <div>
    <div class="ditug pin">
      <van-row>
        <van-col span="4">
          <div class="huidisdf" v-if="!name" @click="deng">
            <img src="../../assets/img/tou.png" />
          </div>
          <el-upload v-else class="avatar1-uploader" :headers="headers"  :action="urls()" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
					<div class="huidisdf">
            <img :src="urlsds()" />
          </div>
				</el-upload>
        </van-col>
        <van-col span="20" @click="deng" v-if="!name">
          <div class="dazi">登录</div>
          <div>点击登录</div>
        </van-col>
        <van-col span="20"  v-else>
          <div class="dazi">{{ name }}</div>
          <div>{{ schoolName }}</div>
        </van-col>
      </van-row>
    </div>
    <div class="pin">
      <van-cell value="" is-link @click="jilu">
        <template #title>
          <img src="../../assets/img/jl.png" class="dygimg" />我的学习记录
        </template>
      </van-cell>
      <van-cell value="" is-link @click="lks">
        <template #title>
          <img src="../../assets/img/lk.png" class="dygimg" />我的申报记录
        </template>
      </van-cell>
      <!-- <van-cell value="" is-link>
        <template #title>
          <img src="../../assets/img/bz.png" class="dygimg" />帮助中心
          
        </template>
      </van-cell> -->
      <van-cell value="" is-link @click="xiuga">
        <template #title>
          <img src="../../assets/img/xiu.png" class="dygimg" />修改密码
        </template>
      </van-cell>
      <van-cell value="" is-link @click="tui">
        <template #title>
          <img src="../../assets/img/tui.png" class="dygimg" />退出登录
        </template>
      </van-cell>
    </div>
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import {usewxrlogout,usercentermodifyheadur,fileossupload,siteurl,usercenterinfo} from "@/api/home";
import { Toast } from "vant";
import dibu from "@/components/index/di";
export default {
  data() {
    return {
      img: "https://file.51xiaoping.com/",
      headPhotoUrl: localStorage.getItem("headPhotoUrl"),
      name: localStorage.getItem("name"),
      schoolName: localStorage.getItem("schoolName"),
      imgUrl: require('../../assets/img/tou.png'),
      headers: {
        token: "", //文件上传请求头
      },
    };
  },
  watch: {},
  components: { dibu },
  methods: {
    usercenterinfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.setItem("headPhotoUrl", res.data.data.teacher.headPhotoUrl);
          localStorage.setItem("name", res.data.data.teacher.name);
          localStorage.setItem("schoolName", res.data.data.teacher.schoolName);
          localStorage.setItem("userId", res.data.data.userId);
          localStorage.setItem("roleType", res.data.data.roleType);
          localStorage.setItem("schoolId", res.data.data.schoolId);
          localStorage.setItem("groupId", res.data.data.groupId);
          that.img=res.data.data.hostUrl
          // if(that.isSettingPwdQuestion=0){
          //   that.$router.push({
          //     path: "/security",
          //   });
          //   return false
          // }
          if(that.path=='/newpassword'){
            that.$router.push({
              path: "/index",
            });
          }else{
            if(this.$route.query.id){
              let local=siteurl+"#/indexvideo?id="+this.$route.query.id
              window.location.href=local
            }else{
              let local=siteurl+"#/myindex"
              window.location.href=local
            }
          }
        })
        .catch(() => {});
    },
    deng() {
      let local=siteurl+"#/log"
      window.location.href=local
    },
    tui() {
      let that = this;
      let params = {
        openid: localStorage.getItem("openid"),
      };
      usewxrlogout(params)
        .then((res) => {
          localStorage.setItem("token", '');
          localStorage.setItem("name", '');
          localStorage.setItem("schoolName", '');
          localStorage.setItem("headPhotoUrl", '');
          that.schoolName=''
          that.name=''
          that.headPhotoUrl=''
        })
        .catch(() => {});
    },
    jilu(){
      if(this.name){
        this.$router.push({
        path: "/record",
      });
      }else{
        this.deng()
      }
    },
    lks(){
      if(this.name){
        this.$router.push({
        path: "/declareindex",
      });
      }else{
        this.deng()
      }
    },
    xiuga(){
      if(this.name){
        this.$router.push({
          path: "/password",
        });
      }else{
        this.deng()
      }
    },
  
    usercentermodifyheadur(){
      let that = this;
      let params = {
        url: this.headPhotoUrl
      };
      usercentermodifyheadur(params)
        .then((res) => {
          
        })
        .catch(() => {});
    },
    urls(){
      return fileossupload
    },
    handleAvatarSuccess(res, file) {
				this.headPhotoUrl = res.data[0].fileName
        this.usercentermodifyheadur()
			},
			beforeAvatarUpload(file) {
				this.loading = true
				const isLt2M = file.size / 1024 / 1024 < 10;
				if(!isLt2M) {
					Toast("上传头像图片大小不能超过 10MB!！")
				}
				return isLt2M;
			},
      urlsds(){
        let exp=this.headPhotoUrl
        if (exp!=='null'&&exp!==''&&exp!==null){ 
          return this.img+this.headPhotoUrl
        }else{
          return this.imgUrl
        }
        
      }
  },
  mounted() {
    this.headers.token = localStorage.getItem("token");
    if(this.headers.token){
      this.usercenterinfo()
    }
    this.headPhotoUrl=localStorage.getItem("headPhotoUrl")
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/index.vue